module.exports = __webpack_public_path__ + "static/media/logo-si-cittru.e9dcd2ad.png";